import { styled } from "@mui/system";
import { Box } from "@mui/material";

export const ChatInterfaceStyles = styled(Box)(({ theme, isDisabled }) => ({
  "&.chatContainer": {
    flexGrow: 1,
    maxWidth: "100%",
    maxHeight: "100%",
    height: "100%",
    backgroundColor: theme.palette.grey.light2, // Custom grey background color
    borderRadius: theme.spacing(1), // Equivalent to 8px
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  "& .messagesContainer": {
    flexGrow: 1,
    overflowY: "auto",
    overflowX: "hidden",
    width: "100%",
    paddingBottom: theme.spacing(2), // Equivalent to 16px
    backgroundColor: theme.palette.grey.sky, // Custom light blue background color
    display: "flex",
    flexDirection: "column",
    paddingRight: theme.spacing(2), // Equivalent to 16px
    paddingLeft: theme.spacing(2), // Equivalent to 16px
    paddingTop: theme.spacing(2), // Equivalent to 16px
    maxHeight: "100%",
    height: "100%",
    alignItems: "center",
  },
  "& .replyButtonContainer": {
    display: "flex",
    justifyContent: "flex-start",
    alignSelf: "flex-start",
    width: "100%",
    marginTop: theme.spacing(0.5),
    marginLeft: theme.spacing(4), // Align with bot message content
    gap: theme.spacing(0.5), // Add space between buttons
  },
  "& .replyButton": {
    color: theme.palette.grey.medium,
    fontSize: "0.75rem",
    padding: theme.spacing(0.25, 0.5),
    minWidth: "auto",
    textTransform: "none",
    borderRadius: theme.spacing(1), // Add rounded edges
    "&:hover": {
      backgroundColor: theme.palette.grey.light, // Darker background on hover
      color: theme.palette.grey.dark,
    },
    "& .MuiTypography-root": {
      color: theme.palette.grey.medium,
      fontSize: theme.typography.pxToRem(12),
    },
    "&:hover .MuiTypography-root": {
      color: theme.palette.grey.dark, // Ensure text color changes on hover
    },
  },
  "& .inputContainer": {
    display: "flex",
    alignItems: "center",
    paddingLeft: theme.spacing(2), // Equivalent to 16px
    backgroundColor: theme.palette.white.main, // Custom white background color
    borderTop: `0.5px solid ${theme.palette.grey.main}`, // Custom border color
  },
  "& .sendButton": {
    marginLeft: 0,
    color: theme.palette.primary.main, // Primary color for the send button
  },
  "& .sendIcon": {
    fontSize: theme.typography.pxToRem(40), // Icon size remains in pixels for consistency
    background: isDisabled
      ? theme.palette.grey.medium
      : theme.palette.primary.main, // Dynamic color based on disabled state
    borderRadius: "50%",
    padding: theme.spacing(1), // Equivalent to 8px
    color: theme.palette.white.main, // Icon color remains white
  },
  "& .chatBotMessageHeader": {
    display: "flex",
    alignItems: "flex-start",
    alignSelf: "flex-start",
    marginRight: theme.spacing(0.5), // Equivalent to 4px
    marginLeft: theme.spacing(0.5), // Equivalent to 4px
    color: theme.palette.primary.main, // Custom dark grey color
  },
  "& .chatBotMessageHeaderText": {
    alignItems: "flex-start",
    alignSelf: "flex-start",
    fontSize: theme.typography.pxToRem(16), // Use rem for font sizing
    marginLeft: theme.spacing(0.5), // Equivalent to 4px
    fontWeight: 600,
  },
  "& .nameAndRole": {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
  },

  "& .roleText": {
    fontSize: theme.typography.pxToRem(11),
    fontWeight: 400,
    color: theme.palette.grey[600],
  },

  "& .dateHeaderText": {
    fontSize: theme.typography.pxToRem(10),
    color: theme.palette.grey.medium,
    fontWeight: 550,
  },
  "& .userMessageHeader": {
    display: "flex",
    alignItems: "end",
    alignSelf: "flex-end",
  },
  "& .rightAlignedUserLabel": {
    display: "flex",
    justifyContent: "flex-end",
  },

  "& .userMessageHeaderText": {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 600,
    color: theme.palette.text.primary,
  },

  "& .rightAlignedDate": {
    display: "flex",
    justifyContent: "flex-end",
  },

  "& .leftAlignedDate": {
    display: "flex",
    justifyContent: "flex-start",
  },
  "& .textField": {
    "& .MuiInput-underline:before": {
      borderBottom: "none", // Remove default underline before hover
    },
    "& .MuiInput-underline:hover:before": {
      borderBottom: "none", // Remove underline on hover
    },
    "& .MuiInput-underline:after": {
      borderBottom: "none", // Remove default underline after focus
    },
  },
}));

export default ChatInterfaceStyles;
